export default __webpack_public_path__ + "static/media/CandidaLovelace.43851731.png";